import { UnSubscribable } from '@core/un-subscrible';
import { Directive, Self, ElementRef, Renderer2, OnInit, AfterViewInit } from '@angular/core';
import { OverlayContainer, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { EigOverlayContainer } from '@core/services/eig-overlay/eig-overlay-container';
import { ComponentPortal } from '@angular/cdk/portal';
import { EigProgressSpinnerComponent } from '../eig-progress-spinner/eig-progress-spinner.component';
import { BehaviorSubject } from 'rxjs';
import { takeUntil, delay } from 'rxjs/operators';


@Directive({
    selector: 'eig-block-ui, [eigBlockUIDirective]',
    providers: [
        {
            provide: OverlayContainer, useClass: EigOverlayContainer
        }, Overlay
    ]
})
export class EigBlockUIDirective extends UnSubscribable implements OnInit, AfterViewInit {

    isShow = false;

    private overlayRef: OverlayRef;
    private componentPortal: ComponentPortal<EigProgressSpinnerComponent>;

    private blockUI$ = new BehaviorSubject<boolean>(false);
    private offSet = 0;

    constructor(
        @Self() private overlayContainer: OverlayContainer,
        @Self() private overlay: Overlay,
        private renderer: Renderer2,
        private elementRef: ElementRef<HTMLElement>) {
        super();
        this.componentPortal = new ComponentPortal(EigProgressSpinnerComponent);
    }

    ngOnInit(): void {
        this.blockUI$
            .pipe(
                takeUntil(this.unsubscribeAll),
                delay(0))
            .subscribe((show: boolean) => {
                this.isShow = show;
                if (show === true) {
                    this.attachBlockUI();
                } else {
                    this.detachBlockUI();
                }
            });
    }

    ngAfterViewInit(): void {
        this.offSet = this.calculateOffSet();
        this.createOverlayRef(this.offSet);
    }

    show(): void {
        this.blockUI$.next(true);
    }

    hide(): void {
        this.blockUI$.next(false);
    }

    private attachBlockUI(): void {
        this.detachBlockUI();
        this.renderer.addClass(this.getContainer(), 'block-ui-container');

        this.overlayRef.attach(this.componentPortal);
        this.renderer.setStyle(this.overlayRef.backdropElement, 'top', `${this.offSet}px`);
    }

    private detachBlockUI(): void {
        this.renderer.removeClass(this.getContainer(), 'block-ui-container');
        if (this.overlayRef) {
            // this.overlayRef.dispose();
            this.overlayRef.detach();
            this.overlayRef.detachBackdrop();
        }

        (this.overlayContainer as EigOverlayContainer).removeSubContainer();
    }

    private createOverlayRef(offSet: number): void {
        (this.overlayContainer as EigOverlayContainer).setContainer(this.getContainer());

        this.overlayRef = this.overlay.create({
            hasBackdrop: true,
            backdropClass: 'eig-overlay-backdrop',
            positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(`${offSet}px`),
        });
    }

    private getContainer(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    calculateOffSet(): number {
        if (this.elementRef.nativeElement.tagName.toLowerCase() === 'table') {
            const offSet = this.elementRef.nativeElement.getElementsByTagName('thead')[0].clientHeight;
            return offSet;
        }

        return 0;
    }
}
